module.exports = __webpack_public_path__ + "img/4.efe9b3bc.png";